//=============================================================================
//                       <--- Developed By Icon Team ---> 18 January 2021
//=============================================================================

// npm packages
import React, { useState, useEffect,useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";

// material-ui
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";

// material-ui icons
import ArrowBackOutlinedIcon from "@material-ui/icons/ArrowBackOutlined";
import { useTranslation } from 'react-i18next';

import Context from 'context/context';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: 20,
  },
  paper: {
    height: 140,
    width: 100,
  },
  control: {
    padding: theme.spacing(2),
  },
  country: {
    flexGrow: 1,
  },
  texts: {
    paddingTop: 15,
    fontSize: 21,
  },
}));

export default function ViewLocations() {
  const history = useHistory();
  const location = useLocation();
  const classes = useStyles();
  const [user, setUser] = useState([]);
  const { t , i18n}= useTranslation()
  const { state, dispatch } = useContext(Context);
  // setting customer account data
  useEffect(() => {
    const userArray = [];
    userArray.push(location?.state?.data);
    setUser(userArray);
  }, []);



  return (
    <React.Fragment>
      <Grid style={{ width: "100%", backgroundColor: "#305698" }}>
        <Grid
          xs={12}
          sm={12}
          lg={12}
          style={{
            color: "#fff",
            fontSize: 22,
            alignSelf: "center",
          }}
        >
          <ArrowBackOutlinedIcon
            style={{ fontSize: 28, verticalAlign: "sub", cursor: "pointer" }}
            onClick={() => {
              history.goBack();
            }}
          />
          &nbsp; {t('Ship To Details')}
        </Grid>
      </Grid>
      {}
      {user.map((item) =>
        user.length > 0 ? (
          <Grid container className={classes.root}>
            <Grid xs={4} sm={4} lg={4}>
              <div style={{ paddingBottom: 20 }}>
                <div style={{ color: "#707070", fontSize: "1rem" }}>
                  {t('Ship To ID')}{" "}
                </div>
                <div style={{ color: "#000000", fontSize: "1.125rem" }}>
                  {item?.["customer_account_number"]}{" "}
                </div>
              </div>
            </Grid>
            <Grid xs={4} sm={4} lg={4}>
              <div style={{ paddingBottom: 20 }}>
                <div style={{ color: "#707070", fontSize: "1rem" }}>
                  {t('Ship To Name')}{" "}
                </div>
                <div style={{ color: "#000000", fontSize: "1.125rem" }}>
                  {item?.["Customer_Account.customer_name"]}
                </div>
              </div>
            </Grid>
            <Grid xs={4} sm={4} lg={4} />
            <Grid xs={4} sm={4} lg={4}>
              <div style={{ paddingBottom: 20 }}>
                <div style={{ color: "#707070", fontSize: "1rem" }}>
                  {t('Bill To ID')}{" "}
                </div>
                <div style={{ color: "#000000", fontSize: "1.125rem" }}>
                  {item?.["customer_billto_account_number"]}{" "}
                </div>
              </div>
            </Grid>
            <Grid xs={4} sm={4} lg={4}>
              <div style={{ paddingBottom: 20 }}>
                <div style={{ color: "#707070", fontSize: "1rem" }}>
                  {t('Country')}{" "}
                </div>
                <div style={{ color: "#000000", fontSize: "1.125rem" }}>
                  {item?.["Customer_Account.customer_address_country_code"]}
                </div>
              </div>
            </Grid>
            <Grid xs={4} sm={4} lg={4} />
            <Grid xs={4} sm={4} lg={4}>
              <div style={{ paddingBottom: 20 }}>
                <div style={{ color: "#707070", fontSize: "1rem" }}>
                  {state?.userInfo?.loyalty_organization_name === 'Henry Schein Dental'?t('Location'):t('Address')}
                </div>
                <div style={{ color: "#000000", fontSize: "1.125rem" }}>
                  {item?.["Customer_Account.customer_address_city_name"] +
                    ", " +
                    item?.["Customer_Account.customer_address_state_code"] +
                    ", " +
                    item?.["Customer_Account.customer_address_country_code"]}
                </div>
              </div>
            </Grid>
            <Grid xs={4} sm={4} lg={4}>
              <div style={{ paddingBottom: 20 }}>
                <div style={{ color: "#707070", fontSize: "1rem" }}>{t('Status')}</div>
                <div style={{ color: "#000000", fontSize: "1.125rem" }}>
                  {item?.["is_active"] ? (
                    <span style={{ color: "green" }}>{t("Active")}</span>
                  ) : (
                    <span style={{ color: "red" }}>{t("InActive")}</span>
                  )}
                </div>
              </div>
            </Grid>
            <Grid xs={4} sm={4} lg={4} />
            <Grid xs={4} sm={4} lg={4} />
            <Grid xs={4} sm={4} lg={4} />
          </Grid>
        ) : (
          history.goBack()
        )
      )}
    </React.Fragment>
  );
}
